import { CheckedAddress } from '@sparkdotfi/common-universal'
import { SquareArrowOutUpRight } from 'lucide-react'

import { useBlockExplorerAddressLink } from '@/domain/hooks/useBlockExplorerAddressLink'
import { Address } from '@/ui/atoms/address/Address'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { cn } from '@/ui/utils/style'

interface BlockExplorerAddressLinkProps {
  address: CheckedAddress
  chainId?: number
  className?: string
  compact?: boolean
  'data-testid'?: string
}

export function BlockExplorerAddressLink({
  address,
  chainId,
  className,
  compact,
  'data-testid': testId,
}: BlockExplorerAddressLinkProps) {
  const contractLink = useBlockExplorerAddressLink({ address, chainId })

  return contractLink ? (
    <ExternalLink
      to={contractLink}
      variant="unstyled"
      className={cn(
        'flex w-full max-w-64 items-center gap-1 text-inherit hover:text-inherit hover:underline',
        className,
      )}
      data-testid={testId}
    >
      <Address
        address={address}
        postfix={<SquareArrowOutUpRight className="icon-size-xs icon-secondary shrink-0" />}
        compact={compact}
      />
    </ExternalLink>
  ) : (
    <span className={cn('flex w-full max-w-64 items-center gap-1', className)} data-testid={testId}>
      <Address address={address} />
    </span>
  )
}
